import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import './PublicaConNosotros.css';

const Catalogo = ({
  productosDestacados,
  onProductoClick,
  productoSeleccionado,
  setCantidad,
  cantidad,
  manejarClickPublicar,
  mostrarCatalogo,
}) => {
  const seleccionarProducto = (producto) => {
    onProductoClick(producto);
  };

  const restarCantidad = () => {
    setCantidad(Math.max(1, cantidad - 1));
  };

  return (
    <div>
      {mostrarCatalogo && (
        <section id="catalogo" className="publish-catalog">
          <div className="publish-heading">
            <p>Publicar en Cannubis</p>
            <h2>Seleccioná el tipo de aviso</h2>
          </div>

          <div className="publish-plan-grid">
            {productosDestacados.map((producto) => {
              const activo = productoSeleccionado?.Idproducto === producto.Idproducto;
              const destacado = producto.Idproducto === 3;
              const propiedades = String(producto.properties || '')
                .split('\n')
                .map((item) => item.trim())
                .filter(Boolean);

              return (
                <button
                  key={producto.Idproducto}
                  type="button"
                  className={`publish-plan ${activo ? 'active' : ''} ${destacado ? 'featured' : ''}`}
                  onClick={() => seleccionarProducto(producto)}
                >
                  <span className="publish-plan-label">{destacado ? 'Recomendado' : 'Plan'}</span>
                  <strong>{producto.Nombre}</strong>
                  <small>{producto.Descripcion}</small>

                  {propiedades.length > 0 && (
                    <ul>
                      {propiedades.slice(0, 4).map((propiedad) => (
                        <li key={propiedad}>
                          <FontAwesomeIcon icon={faCheck} />
                          {propiedad}
                        </li>
                      ))}
                    </ul>
                  )}

                  <span className="publish-plan-action">
                    Ver detalle <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </button>
              );
            })}
          </div>

          {productoSeleccionado && (
            <aside className="publish-selection">
              <div>
                <span>Plan seleccionado</span>
                <h3>{productoSeleccionado.Nombre}</h3>
                <p>{productoSeleccionado.LongDesc || productoSeleccionado.Descripcion}</p>
              </div>

              <div className="publish-selection-actions">
                {productoSeleccionado.Idproducto !== 3 ? (
                  <>
                    <div className="publish-stepper" aria-label="Cantidad">
                      <button type="button" onClick={restarCantidad} aria-label="Restar">
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                      <output>{cantidad}</output>
                      <button type="button" onClick={() => setCantidad(cantidad + 1)} aria-label="Sumar">
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                    <button type="button" className="publish-primary">
                      Comprar plan
                    </button>
                  </>
                ) : (
                  <button type="button" className="publish-primary" onClick={manejarClickPublicar}>
                    Empezar a publicar ahora
                  </button>
                )}
              </div>
            </aside>
          )}
        </section>
      )}
    </div>
  );
};

export default Catalogo;
